
<div class="card">
  <div class="card-body mb-2">

    <div class="row">
      <div class="col-md-12">
        <h4 *ngIf="userCourseType !== 'contractor'">Section {{ sectionData.sectionOrder }} - Training Questions</h4>
        <h4 *ngIf="userCourseType === 'contractor'">Section {{ sectionData.sectionOrder }} - Outage Acceptance</h4>
        <p><b>Please complete all the questions</b></p>

        <h4>Questions</h4>
        <div class="induction-container">
          <div class="row">
            <ng-container *ngFor="let questionGroup of mainForm.get('questions').controls; let q_index = index">
              <div class="col-md-6 question-container">
                <!-- question -->
                <p>Q{{q_index + 1}}. {{ questionGroup.get('question.text').value }}</p>

                <!-- answers -->
                <label class="answer-container" *ngFor="let answer of questionGroup.get('question.options').value">
                  <div class="form-group">
                    <p-radioButton
                      label="{{answer.text}}"
                      class="form-control"
                      name="group_{{ questionGroup.get('question.id').value }}"
                      [value]="answer.id"
                      [formControl]="questionGroup.get('answer')"
                    >
                    </p-radioButton>
                  </div>
                </label>

              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <a [routerLink]="backLink" [queryParams]="{type: userCourseType}" class="secondary-link-btn">course overview</a>
        <button type="button" *ngIf="!isComplete" [disabled]="!mainForm.valid" class="my-2 btn btn-round btn-sm btn-success float-right" (click)="submitAnswers()">Submit</button>
        <button type="button" *ngIf="isComplete" class="my-2 btn btn-round btn-sm btn-primary float-right" (click)="onGoToNextSection.emit()">Next</button>
      </div>
    </div>
  </div>
</div>
